module.exports = __webpack_public_path__ + "static/new-core-alternative-dda0d191251662d16923568b2399ab49.png";